"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressOrState = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line import/no-cycle
var control_1 = require("../control");
function AddressOrState(_a) {
    var _b, _c;
    var value = _a.value, onChange = _a.onChange, schema = _a.schema, name = _a.name, fieldPath = _a.fieldPath;
    return (react_1.default.createElement("div", { style: {
            width: 400,
        } },
        react_1.default.createElement(core_ui_1.Flexbox, null,
            react_1.default.createElement(core_ui_1.RadioButtonGroup, { direction: "horizontal", name: "address-or-state", value: getRadioValue(value), options: [
                    {
                        value: 'address',
                        label: 'Address',
                    },
                    {
                        value: 'state',
                        label: 'State only',
                    },
                ], onChange: function (radioValue) {
                    if (radioValue === 'address') {
                        onChange({
                            address: null,
                        });
                    }
                    if (radioValue === 'state') {
                        onChange({
                            state: '',
                        });
                    }
                } }),
            value && (react_1.default.createElement(core_ui_1.TextLink, { underlineOnHover: true, onClick: function () {
                    onChange(undefined);
                } }, "Clear"))),
        value && react_1.default.createElement(core_ui_1.Spacing, { height: 12 }),
        (value === null || value === void 0 ? void 0 : value.state) !== undefined && ((_b = schema.properties) === null || _b === void 0 ? void 0 : _b.state) && (react_1.default.createElement(control_1.SchemaInputControl, { schema: schema.properties.state, fieldPath: fieldPath + ".state", name: name, type: schema.properties.state.inputType, metadata: schema.properties.state.inputMetadata })),
        (value === null || value === void 0 ? void 0 : value.address) !== undefined && ((_c = schema.properties) === null || _c === void 0 ? void 0 : _c.address) && (react_1.default.createElement(control_1.SchemaInputControl, { schema: schema.properties.address, fieldPath: fieldPath + ".address", name: name, type: schema.properties.address.inputType, metadata: schema.properties.address.inputMetadata }))));
}
exports.AddressOrState = AddressOrState;
function getRadioValue(value) {
    if ((value === null || value === void 0 ? void 0 : value.address) !== undefined) {
        return 'address';
    }
    if ((value === null || value === void 0 ? void 0 : value.state) !== undefined) {
        return 'state';
    }
    return undefined;
}
